import { useEffect, useState } from "react";

import { UserDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";
import { $count, $isemail, $length } from "foundation-ts/commons";
import { Nullable, UUID } from "foundation-ts/types";

import { G1Button } from "@/components/G1Button";
import { SearchUsers } from "@/components/admin/SearchUsers";
import { UserParameters } from "@/components/UserInfos/UserInfos";
import { useUsers } from "@/hooks/useUsers";
import { G1Icon } from "@/utils/icons";

interface UsersTabProps {
    maxUsers: number;
    onAddUser: () => void;
    onRefreshUsers : () => void;
    onViewUser: (user?: UserParameters) => void;
}

export const UsersTab = (props: UsersTabProps) => {
    const { maxUsers, onAddUser, onRefreshUsers, onViewUser } = props;
    const { data: users } = useUsers();
    const [filteredUsers, setFilteredUsers] = useState<UserParameters[]>([]);

    const onSearch = async (search?: Nullable<string>) => {
        if ($isemail(search)) {
            setFilteredUsers(users?.filter(u => u.email === search)?.map(u => _toUserParameters(u)) ?? []);
        } else if ($length(search) > 0) {
            setFilteredUsers(users?.filter(u => u.lastName.toLowerCase().startsWith(search!.toLowerCase()))?.map(u => _toUserParameters(u)) ?? []);
        } else {
            setFilteredUsers(users?.map(u => _toUserParameters(u)) ?? []);
        }
    }

    const handleViewUser = (userId: UUID) => {
        const user = filteredUsers?.find(u => u.apid === userId);
        onViewUser(user);
    }

    const AddUserButton = (
        <G1Button key="addUser" component="form" variant="important" title="Ajouter" leftIcon={<G1Icon.Plus />} isDisabled={$count(users) >= maxUsers} onClick={onAddUser} />
    );

    const RefreshButton = (
        <G1Button key="refresh" component="form" variant="normal" title="Rafraichir" leftIcon={<G1Icon.Refresh />} onClick={onRefreshUsers} />
    )

    useEffect(() => {
        setFilteredUsers(users?.map(u => _toUserParameters(u)) ?? []);
    }, [users]);

    return (
        <>
            <SearchUsers displayIcon displayOrganizationName displayRole isAdminCorporate
                         users={filteredUsers} maxUsersCount={maxUsers} actionButtonList={[AddUserButton, RefreshButton]}
                         onSearch={onSearch}
                         onItemClick={handleViewUser} />
        </>
    );
};

function _toUserParameters(userDto: UserDto): UserParameters {
    return {
        lastName: userDto.lastName.toUpperCase(),
        firstName: userDto.firstName.capitalize(),
        email: userDto.email,
        apid: userDto.apid,
        createdAt: userDto.createdAt,
        userFlags: userDto.userFlags,
    };
}